import { render } from "./DevAppDropDownComponent.vue?vue&type=template&id=a1f72a66"
import script from "./DevAppDropDownComponent.vue?vue&type=script&lang=js"
export * from "./DevAppDropDownComponent.vue?vue&type=script&lang=js"

import "./DevAppDropDownComponent.vue?vue&type=style&index=0&id=a1f72a66&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__